module.exports = __webpack_public_path__ + "img/Baugruppe.b1861cae.svg";